import { settingReduxTypes } from "../constant/Types";

const initialize = {
  isUnread: false,
};

export default function settings(state = initialize, action) {
  let res = {
    ...initialize,
  };
  switch (action.type) {
    case settingReduxTypes.SET_UNREAD_STATUS:
      res = {
        isUnread: action.payload,
      };
      return res;
    default:
      return state;
  }
}
